import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {IProfile, Profile} from 'app/blocks/model/profile.model';
import {ProfileService} from 'app/blocks/service/api/profile.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SUPER_ADMIN_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class ProfileResource extends AbstractEntityResource<IProfile> {
    constructor(profileService: ProfileService, router: Router) {
        super(
            Resource.PROFILES,
            profileService,
            new EntityNavigator(ENTITIES_SUPER_ADMIN_SETUP_BASE_URL, Resource.PROFILES, router),
            new EntityUrlProvider(ENTITIES_SUPER_ADMIN_SETUP_BASE_URL, Resource.PROFILES),
            (entity?) => new Profile(entity),
            (entity) => entity.id
        );
    }
}
